"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetDetailVideo = void 0;
var AssetDetailVideo_1 = require("./AssetDetailVideo");
Object.defineProperty(exports, "AssetDetailVideo", { enumerable: true, get: function () { return AssetDetailVideo_1.AssetDetailVideo; } });
